import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ResourceService } from "./resource.service";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { LoginHistoryFilter, LoginHistoryPageModel } from "../model/login-history.model";

@Injectable({
    providedIn: "root"
})
export class NavigationLogService extends ResourceService<any> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService) {
        super(http, "NavigationLogs", settings.securityApiUrl, authService)
    }

    search(pageNumber: number = 1, pageSize: number = 20, filter: LoginHistoryFilter = {}): Observable<LoginHistoryPageModel> {
        let params = new HttpParams()
            .set("PageNumber", String(pageNumber))
            .set("PageSize", String(pageSize));

        if (filter.searchQuery && filter.searchQuery.trim().length) {
            params = params.set("searchQuery", filter.searchQuery.trim());
        }

        if (filter.action) {
            params = params.set("action", filter.action);
        }

        if (filter.startDate) {
            params = params.set("startDate", filter.startDate);
        }

        if (filter.endDate) {
            params = params.set("endDate", filter.endDate);
        }

        return this.getWithComplement<LoginHistoryPageModel>(`?${params.toString()}`);
    }
}
